import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'
import store from '@/store'

const endpoint = 'letters'
const Actions = crudActions(endpoint)

const periods = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/periods/', { params: queryParams })
    .then(response => {
      commit('PERIODS', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const organizations = ({ commit }) => new Promise((resolve, reject) => {
  axios.get('/organizations/universities/')
    .then(response => {
      commit('ORGANIZATIONS', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const list = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/sent`, { params: queryParams })
    .then(response => {
      commit('LIST', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const history = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  const letter = store.state.letter.history_letter
  axios.get(`/${endpoint}/sent`, {
    params: {
      ...queryParams,
      from_org_id: letter.from_org.id,
      to_org_id: letter.to_org.id,
      period_id: letter.period.id,
    },
  })
    .then(response => {
      commit('LIST', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const regenerateLetter = (_, queryParams) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/regenerate_letter`, { params: queryParams })
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const accepted = ({ commit }, id) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/${id}/accepted/`)
    .then(response => {
      commit('TABLE_ONE', response.data.table1)
      commit('TABLE_TWO', response.data.table2)
      resolve(response.data)
    })
    .catch(error => {
      reject(error)
    })
})

const send = (ctx, data) => new Promise((resolve, reject) => {
  const params = new FormData()
  params.append('letter_status', data.body.letter_status)
  params.append('letter_file', data.body.letter_file)
  axios.patch(`/${endpoint}/${data.id}/`, params)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

Actions.list = list

export default {
  ...Actions,
  periods,
  organizations,
  regenerateLetter,
  send,
  accepted,
  history,
}
